import WaveSurfer from 'wavesurfer.js';

export const WaveSurferPauseFunctions = new Map<WaveSurfer, () => void>();
